import AddressForm from "./address_form";
import { cursorWaitOn } from "../helpers/cursor_wait";
import Route from '../route';
$(function () {

    if (Route === ("account-address-book")) {

        const FormId = ".deliveryAddressForm";
        const DeliveryModal = $(`#deliveryAddressEdit`);

        let $modalSpinner = $(".loading", DeliveryModal);

        let DeliveryAddressForm = new AddressForm({
            form_id: FormId,
            read_url: `/delivery-address/read`,
        });

        // Add form submit listener and callback
        DeliveryAddressForm.addSubmitListener((response) => {

            let isFirst = $('.delivery-address').length === 0;

            if (!response.status) {
                DeliveryAddressForm.showErrors(response.data);
                DeliveryAddressForm.turnFormLoadingOff();
            } else if (isFirst) {
                axios
                    .patch(`/delivery-address/update-default/${response.data.id}`, { value: true })
                    .then(function (response) {
                        window.location.reload();
                    })
                    .catch(function (error) {

                    });
            } else {
                window.location.reload();
            }

        });

        // When modal opens, load the data
        DeliveryModal.on("shown.bs.modal", function (e) {
            let id = null;
            let button = e.relatedTarget;

            DeliveryAddressForm.hideDropdown('add_lookuplist');
            const $slAccountSelect = $('.deliveryAddressForm select[name="slAccount"]');
            const $countrySelect = $('.deliveryAddressForm select[name="country"]');
            const $postCodeInput = $('.deliveryAddressForm input[name="postCode"]');

            if ($(button).hasClass("edit")) {
                $modalSpinner.removeClass('d-none');
                id = $(button).data("id");
                DeliveryAddressForm.setAction("/delivery-address/update/" + id);

                // Loads the data into the DeliveryModal Form
                DeliveryAddressForm.populateFields(id, (form, data) => {

                    $modalSpinner.addClass("d-none");
                    $(".form-fields", DeliveryModal).removeClass("d-none");

                    const selectedAccountNumber = $('#selectedAccountNumber', form).val();
                    $slAccountSelect.updateVal(selectedAccountNumber).setDisabled(true);

                    const selectedCountry = $('.selectedCountry', form).val();
                    $countrySelect.updateVal(selectedCountry).setDisabled(true);

                    $postCodeInput.prop("disabled", true).addClass("disabled");
                });
            } else {
                DeliveryAddressForm.setAction("/delivery-address/create");
                $(".form-fields", DeliveryModal).removeClass("d-none");
                if (!$slAccountSelect.val()) {
                    $slAccountSelect.updateVal("").setDisabled(false).setDisplayText("");
                }
                $countrySelect.updateVal("").setDisabled(false).setDisplayText("").trigger("change");
                $postCodeInput.prop("disabled", false).removeClass("disabled");
            }
        }).on("hidden.bs.modal", function () {
            $(".form-fields", this).addClass("d-none");
            $modalSpinner.addClass("d-none");
            DeliveryAddressForm.emptyForm();
        });

        // Change Modal title for Create / Edit forms
        DeliveryModal.on("show.bs.modal", function (e) {
            let button = e.relatedTarget;
            let type = $(button).hasClass("edit") ? "Edit" : "Create";
            $(".modal-title", DeliveryModal).text(`${type} Delivery Address`);
        });

        // Remove button click
        $(".remove-address-btn").on("click", function () {
            let id = $(this).closest(".delivery-address").data("id");
            $(this).prop("disabled", true).html("Removing..");
            axios
                .delete(`/delivery-address/delete/${id}`)
                .then(function (response) {

                    // If the removed element was checked, then check the first one
                    if ($(`.delivery-address[data-id="${id}"] .default-address-checked`).is(':checked')) {
                        $('.delivery-address .default-address-checked').first().prop('checked', true).trigger('change');
                    }

                    $(`.delivery-address[data-id="${id}"]`).remove();

                    if ($('.delivery-address').length === 1) {
                        if (!$('.delivery-address .default-address-checked').is(':checked')) {
                            $('.delivery-address .default-address-checked').prop('checked', true).trigger('change');
                        }
                    }

                    if ($('.delivery-address').length === 0) {
                        $('.no-delivery-warning').removeClass('hidden');
                    }

                })
                .catch(function (error) {

                });
        });

        $('.default-address-checked').on('change', function () {

            let value = $(this).is(':checked');
            cursorWaitOn();

            // untick other default checkboxes
            if (value === true) {
                $('.default-address-checked').prop('checked', false);
                $(this).prop('checked', true)
            }

            let id = $(this).data("id");
            axios
                .patch(`/delivery-address/update-default/${id}`, { value: value })
                .then(function (response) {
                    window.location.reload();
                })
                .catch(function (error) {

                });
        });

        $(document).on('change', '.deliveryAddressForm #countrySelect', function () {

            let $deliveryAddressForm = $(this).closest('.deliveryAddressForm');
            let selectedCountry = $(this).val();
            const selectedCountryName = $('option:selected', $(this)).data('name');

            if (selectedCountry === 'GB') {
                $deliveryAddressForm.find('#findAddressBtn').parent('div').removeClass('d-none'); // Show the button by removing 'd-none' from the parent div
            } else {
                $deliveryAddressForm.find('#findAddressBtn').parent('div').addClass('d-none'); // Hide the button by adding 'd-none' to the parent div
            }

            $deliveryAddressForm.find('.selectedCountryName').val(selectedCountryName);
        });
    }
});
